import { render } from "./basic-table.vue?vue&type=template&id=1aaaf481&scoped=true"
import script from "./basic-table.vue?vue&type=script&lang=js"
export * from "./basic-table.vue?vue&type=script&lang=js"

import "./basic-table.vue?vue&type=style&index=0&id=1aaaf481&scoped=true&lang=css"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aaaf481"]])

export default __exports__